import React from 'react';

import { css } from '@emotion/react';
import { colors, gutterSizes, fontWeights } from '@gumtree/ui-library/src/base/theme';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import WithVisibilityObserver from '@gumtree/shared/src/util/element-visibility/visibility-observer';
import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';

export const StyledFilterBlock = ({
    children,
    filterName,
    ...props
}: React.PropsWithChildren<{ filterName?: string }>) => {
    const onVisible = () => {
        filterName &&
            trackGA4Event<GA4.SearchFilterEvent>({
                event: 'impress_search_filter',
                filterName: filterName,
            });
    };
    return (
        <WithVisibilityObserver
            {...qaAttribute('filter-block-categories')}
            css={css`
                border-top: 1px solid ${colors.bark20};
                padding-top: ${gutterSizes.xlarge};
                margin-top: ${gutterSizes.large};

                .radio-switch + label {
                    font-weight: ${fontWeights.normal};
                }
            `}
            {...props}
            onVisible={onVisible}
        >
            {children}
        </WithVisibilityObserver>
    );
};
